export default "__VITE_ASSET__C8Taocbn__"